export default __webpack_public_path__ + "static/realWorldImage4-85936350b053d9e718b0eedf6c700a84.webp";